import React from 'react';
import { WithTranslation } from 'next-i18next';

import H3 from 'components/typo/Heading/H3';
import P from 'components/typo/P';
import PersonReferenceBadge from 'components/PersonReferenceBadge';
import { withTranslation } from 'lib/i18n';

import pic from '../../images/Picture_MilanPolak@2x.png';
import logo from '../../images/logo-different@2x.png';

import ReferenceWrap from './styled/ReferenceWrap';

const Reference: React.FC<WithTranslation> = props => (
  <ReferenceWrap>
    <H3>
      <q>{props.t('business.index.case_study.reference.title')}</q>
    </H3>
    <P dark>{props.t('business.index.case_study.reference.paragraph_1')}</P>
    <P dark>{props.t('business.index.case_study.reference.paragraph_2')}</P>
    <P dark>{props.t('business.index.case_study.reference.paragraph_3')}</P>

    <PersonReferenceBadge
      pic={pic}
      logo={logo}
      name={props.t('business.index.case_study.reference.name')}
      job={props.t('business.index.case_study.reference.job')}
    />
  </ReferenceWrap>
);

export default withTranslation('pages')(Reference);
